import SubscriptionCancellationForm from "./VueComponents/Subscriptions/Cancellation/SubscriptionCancellationForm";

require('./app_bootstrap');

window.Vue = require('vue');

import {flatten} from 'q-flat';
window.vue2Dropzone = require('vue2-dropzone');
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

window.flatPickr = require('vue-flatpickr-component');
import 'flatpickr/dist/flatpickr.css';
window.flatPickrGerman = require('flatpickr/dist/l10n/de');
flatPickrGerman.firstDayOfWeek = 1;

window.numeral = require('numeral');
numeral.register('locale', 'de', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    abbreviations: {
        thousand: 't',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal: function (number) {
        return number === 1 ? 'er' : 'ème';
    },
    currency: {
        symbol: '€'
    }
});
numeral.locale('de');

require('./appConfig');
require('./coreComponents');
require('./packageComponents');
require('./src');
require('./helpers');

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

require('./v2Components');
require('./gtm-tracking');

const VueAwesomeSwiper = require('vue-awesome-swiper/dist/ssr');
Vue.use(VueAwesomeSwiper);

import FaarenUI from 'faaren-ui'
import { BMedia, BCarousel, BCarouselSlide } from "bootstrap-vue";

Vue.use(FaarenUI);
Vue.component('b-media', BMedia)
Vue.component('b-carousel', BCarousel)
Vue.component('b-carousel-slide', BCarouselSlide)
Vue.component('subscription-cancellation-form', SubscriptionCancellationForm)

import StoryblokVue from 'storyblok-vue'
import StoryblokClient from 'storyblok-js-client'

Vue.prototype.$storyapi = new StoryblokClient ({
    accessToken: 'c2rQf3f9sRzde6cW9uY2xAtt'
})


Vue.use (StoryblokVue)

import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);

window.flatten = flatten;

window.ls = require('local-storage');

let appContainer = document.getElementById('app');

if(appContainer !== null){
    new Vue({
        el: '#app',
        data: {
            catalogUrl: 'https://faaren.test/katalog',
            singleUrl: 'https://faaren.test/inserat/'
        },
        mounted(){
            console.log("App geladen..");
        }
    });
}


